import * as t from "io-ts";

export const ObjectComboMappingCodec = t.intersection([
  t.type({
    id: t.string,
    leftObjectId: t.string,
    leftObjectType: t.string,
    rightObjectId: t.string,
    rightObjectType: t.string,
    key: t.string,
    value: t.string,
  }),
  t.partial({
    leftObjectName: t.string,
    rightObjectName: t.string,
    createDttm: t.number,
    lastModifiedDttm: t.number,
  }),
]);

export const ObjectComboMappingArrayCodec = t.array(ObjectComboMappingCodec);

export type ObjectComboMapping = t.TypeOf<typeof ObjectComboMappingCodec>;
export type ObjectComboMappingArray = t.TypeOf<typeof ObjectComboMappingArrayCodec>;
